import { c as _c } from "react/compiler-runtime";
import type { OnboardingRequirementCollectDocument, OnboardingSessionConfig } from '@onefootprint/request-types';
import { FaceModelProvider } from '@onefootprint/vision';
import { useEffect } from 'react';
import type { DeviceInfo } from '@/idv2/utils/get-device';
import { trackAction } from '@/idv2/utils/logger';
import { ImgProcessorsContextProvider } from '../components/image-processors';
import { MissingPermissionsSheetProvider } from '../components/missing-permissions-sheet';
import type { IdDocOutcome } from '../types';
import type { IdDocContext } from './context/id-doc-context';
import { IdDocProvider } from './context/id-doc-context';
import Router from './pages/router';
type IdDocProps = {
  authToken: string;
  device: DeviceInfo;
  requirement: OnboardingRequirementCollectDocument & {
    config: {
      kind: 'identity';
      shouldCollectConsent: boolean;
      shouldCollectSelfie: boolean;
    };
  };
  sandboxOutcome?: IdDocOutcome;
  onboardingConfig: OnboardingSessionConfig;
  onDone: () => void;
};
const IdDoc = t0 => {
  const $ = _c(17);
  const {
    authToken,
    device,
    requirement,
    sandboxOutcome,
    onboardingConfig,
    onDone
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      country: undefined,
      type: undefined
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = device.initialCameraPermissionState || "prompt";
  let t3;
  if ($[1] !== authToken || $[2] !== device || $[3] !== onboardingConfig || $[4] !== requirement || $[5] !== sandboxOutcome || $[6] !== t2) {
    t3 = {
      authToken,
      device,
      requirement,
      isConsentMissing: requirement.config.shouldCollectConsent,
      idDoc: t1,
      allowPdf: false,
      sandboxOutcome,
      cameraPermissionState: t2,
      onboardingConfig
    };
    $[1] = authToken;
    $[2] = device;
    $[3] = onboardingConfig;
    $[4] = requirement;
    $[5] = sandboxOutcome;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const initialContext = t3;
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = [];
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  useEffect(_temp, t4);
  let t5;
  if ($[9] !== onDone) {
    t5 = <FaceModelProvider isSelfieRequired={true}><ImgProcessorsContextProvider><Router onDone={onDone} /></ImgProcessorsContextProvider></FaceModelProvider>;
    $[9] = onDone;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== device || $[12] !== t5) {
    t6 = <MissingPermissionsSheetProvider device={device}>{t5}</MissingPermissionsSheetProvider>;
    $[11] = device;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== initialContext || $[15] !== t6) {
    t7 = <IdDocProvider initialContext={initialContext}>{t6}</IdDocProvider>;
    $[14] = initialContext;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
};
export default IdDoc;
function _temp() {
  trackAction("id-doc:started");
}